var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useCallback, useEffect, useState } from 'react';
import { defineMessages, useIntl } from 'react-intl';
import LoadingContainer from '@/shared/components/loading/LoadingContainer';
import ToastrService from '@/shared/services/ToastrService';
import YesNoModal from '@/shared/components/YesNoModal';
import EditableEnumSelect from '@/shared/components/editable/EditableEnumSelect';
import { useStateService } from '@/shared/services/StateService';
import AuthService from '@/shared/services/AuthService';
import { useGetLegalEntities, } from '@/shared/hooks/legalEntity/useGetLegalEntities';
import { useUpdateLegalEntity } from '@/shared/hooks/legalEntity/useUpdateLegalEntity';
import { useDeleteLegalEntity } from '@/shared/hooks/legalEntity/useDeleteLegalEntity';
import BookyearSettings from '@/modules/settings/GeneralSettings/components/BookyearSettings';
import generalSettingsMessages from '@/modules/settings/GeneralSettings/generalSettingsMessages';
import LegalEntitySelector from './components/LegalEntitySelector';
import LegalEntityHeader from './components/LegalEntityHeader';
import IdentificationSection from './components/IdentificationSection';
import CreateLegalEntityModal from './modals/CreateLegalEntityModal';
import messages from './legalEntitiesMessages';
var containerMessages = defineMessages({
    AddLegalEntity: { id: 'AddLegalEntity', defaultMessage: 'Add legal entity' },
});
var LegalEntitiesContainer = function () {
    var intl = useIntl();
    var stateService = useStateService();
    var hasFeature = AuthService.hasFeature('TenantMoore');
    var _a = useGetLegalEntities(), entities = _a.data, isLoading = _a.isLoading;
    var updateLegalEntity = useUpdateLegalEntity().updateLegalEntity;
    var _b = useDeleteLegalEntity(), deleteLegalEntity = _b.deleteLegalEntity, isDeleting = _b.isLoading;
    var _c = useState(function () { var _a, _b, _c; return (_c = (_b = (_a = stateService.$state) === null || _a === void 0 ? void 0 : _a.params) === null || _b === void 0 ? void 0 : _b.id) !== null && _c !== void 0 ? _c : ''; }), selectedId = _c[0], setSelectedId = _c[1];
    var _d = useState(false), showCreateModal = _d[0], setShowCreateModal = _d[1];
    var _e = useState(false), showDeleteModal = _e[0], setShowDeleteModal = _e[1];
    useEffect(function () {
        if (!hasFeature)
            stateService.gotoState('home');
    }, [hasFeature, stateService]);
    useEffect(function () {
        if (!entities || entities.length === 0)
            return;
        if (selectedId && entities.some(function (e) { return e.id === selectedId; }))
            return;
        setSelectedId(entities[0].id);
    }, [entities, selectedId]);
    var selected = (entities || []).find(function (e) { return e.id === selectedId; }) || null;
    var handleSelect = useCallback(function (entity) {
        setSelectedId(entity.id);
    }, []);
    var handleUpdate = useCallback(function (model) { return __awaiter(void 0, void 0, void 0, function () {
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    _b.trys.push([0, 2, , 3]);
                    return [4 /*yield*/, updateLegalEntity(model)];
                case 1:
                    _b.sent();
                    ToastrService.success(intl.formatMessage(messages.msgChangesSavedForName, { name: model.name }));
                    return [3 /*break*/, 3];
                case 2:
                    _a = _b.sent();
                    return [3 /*break*/, 3];
                case 3: return [2 /*return*/];
            }
        });
    }); }, [updateLegalEntity, intl]);
    var handleUpdateName = useCallback(function (name) {
        if (!selected || selected.name === name)
            return Promise.resolve();
        return handleUpdate(__assign(__assign({}, selected), { name: name }));
    }, [selected, handleUpdate]);
    var handleUpdateAddress = useCallback(function (address) {
        var _a;
        if (!selected)
            return Promise.resolve();
        return handleUpdate(__assign(__assign({}, selected), { street1: address.street1, street2: address.street2, number: address.number, box: address.box, zipCode: address.zipCode, city: address.city, region: (_a = address.region) !== null && _a !== void 0 ? _a : null, countryCode: address.country }));
    }, [selected, handleUpdate]);
    var handleUpdateNumberFormatYear = useCallback(function (value) {
        if (!selected || value == null || value === selected.numberFormatYear)
            return;
        handleUpdate(__assign(__assign({}, selected), { numberFormatYear: value }));
    }, [selected, handleUpdate]);
    var handleUpdateCurrentBookyear = useCallback(function (data) {
        if (!selected)
            return;
        handleUpdate(__assign(__assign({}, selected), { currentBookyear: data }));
    }, [selected, handleUpdate]);
    var handleUpdateNextBookyear = useCallback(function (data) {
        if (!selected)
            return;
        handleUpdate(__assign(__assign({}, selected), { nextBookyear: data }));
    }, [selected, handleUpdate]);
    var handleEntityCreated = useCallback(function (entity) {
        setShowCreateModal(false);
        setSelectedId(entity.id);
    }, []);
    var handleConfirmDelete = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var deletedName, deletedId, remaining, _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!selected)
                        return [2 /*return*/];
                    deletedName = selected.name;
                    deletedId = selected.id;
                    _b.label = 1;
                case 1:
                    _b.trys.push([1, 3, , 4]);
                    return [4 /*yield*/, deleteLegalEntity(deletedId)];
                case 2:
                    _b.sent();
                    ToastrService.success(intl.formatMessage(messages.msgLegalEntityDeleted, { name: deletedName }));
                    remaining = (entities || []).filter(function (e) { return e.id !== deletedId; });
                    setSelectedId(remaining.length > 0 ? remaining[0].id : '');
                    setShowDeleteModal(false);
                    return [3 /*break*/, 4];
                case 3:
                    _a = _b.sent();
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); }, [selected, deleteLegalEntity, entities, intl]);
    if (!hasFeature)
        return null;
    return (_jsxs("div", __assign({ id: "LegalEntitiesPage" }, { children: [_jsxs(LoadingContainer, __assign({ isLoading: isLoading }, { children: [entities && entities.length > 0 && (_jsx(LegalEntitySelector, { entities: entities, selectedId: selectedId, onChange: handleSelect })), _jsxs("div", __assign({ className: "panel" }, { children: [_jsxs("div", __assign({ className: "panel-heading" }, { children: [selected && _jsx(LegalEntityHeader, { entity: selected }), _jsxs("div", __assign({ className: "panel-buttons" }, { children: [_jsxs("button", __assign({ type: "button", id: "newLegalEntityButton", className: "btn btn-inverse", onClick: function () { return setShowCreateModal(true); }, title: intl.formatMessage(containerMessages.AddLegalEntity) }, { children: [_jsx("i", { className: "fa fa-plus" }), _jsx("span", { children: intl.formatMessage(containerMessages.AddLegalEntity) })] })), selected && (_jsxs("button", __assign({ type: "button", id: "deleteLegalEntityButton", className: "btn btn-danger margin5L", onClick: function () { return setShowDeleteModal(true); }, title: intl.formatMessage(messages.Delete) }, { children: [_jsx("i", { className: "fa fa-trash" }), _jsx("span", { children: intl.formatMessage(messages.Delete) })] })))] }))] })), _jsx("div", __assign({ className: "panel-body" }, { children: selected ? (_jsxs(_Fragment, { children: [_jsx(IdentificationSection, { entity: selected, onUpdateName: handleUpdateName, onUpdateAddress: handleUpdateAddress }), _jsxs("div", __assign({ className: "simple-panel control-panel subsection settings-page" }, { children: [_jsx("div", __assign({ className: "panel-title pointer" }, { children: _jsx("span", { children: intl.formatMessage(generalSettingsMessages.BillingSetup) }) })), _jsx("div", __assign({ className: "panel-body form-horizontal form-labels-left" }, { children: _jsxs("div", __assign({ className: "form-group clearfix" }, { children: [_jsx("label", __assign({ className: "control-label col-md-5 col-sm-3" }, { children: intl.formatMessage(generalSettingsMessages.InvoiceNumberFormatYear) })), _jsx("div", __assign({ className: "col-md-7 col-sm-9" }, { children: _jsx(EditableEnumSelect, { enumType: "numberFormatYear", value: selected.numberFormatYear, onChange: handleUpdateNumberFormatYear }) }))] })) }))] })), selected.currentBookyear && (_jsx(BookyearSettings, { data: selected.currentBookyear, type: "CURRENT", label: intl.formatMessage(generalSettingsMessages.CurrentBookyear), onSave: handleUpdateCurrentBookyear, yearFormat: selected.numberFormatYear, disabled: false })), selected.nextBookyear && (_jsx(BookyearSettings, { data: selected.nextBookyear, type: "NEXT", label: intl.formatMessage(generalSettingsMessages.NextBookyear), onSave: handleUpdateNextBookyear, yearFormat: selected.numberFormatYear, disabled: false }))] })) : (entities &&
                                    entities.length === 0 && (_jsx("div", __assign({ className: "alert alert-info", role: "alert" }, { children: intl.formatMessage(messages.msgNoLegalEntities) })))) }))] }))] })), showCreateModal && (_jsx(CreateLegalEntityModal, { show: showCreateModal, onClose: function () { return setShowCreateModal(false); }, onSaved: handleEntityCreated })), showDeleteModal && selected && (_jsx(YesNoModal, { show: true, title: intl.formatMessage(messages.msgConfirmDeleteLegalEntityTitle), message: intl.formatMessage(messages.msgConfirmDeleteLegalEntity, {
                    name: selected.name,
                }), onSave: handleConfirmDelete, onNo: function () { return setShowDeleteModal(false); }, onClose: function () { return setShowDeleteModal(false); }, disabled: isDeleting }))] })));
};
export default LegalEntitiesContainer;
